goog.provide("shadow.js.shim.module$$mui$material$SvgIcon");
goog.provide("module$shadow_js_shim_module$$mui$material$SvgIcon");
shadow.js.shim.module$$mui$material$SvgIcon = shadow.js.nativeProvides["@mui/material/SvgIcon"] = shadow$bridge("@mui/material/SvgIcon");
module$shadow_js_shim_module$$mui$material$SvgIcon.default = shadow.js.shim.module$$mui$material$SvgIcon;
